import { MenuItem, Select, TextField } from '@mui/material';
import { BulkEditColumnDef } from './types';

type Props = {
  column: BulkEditColumnDef;
  value: string;
  onChange: (value: string) => void;
  error?: string;
};

const seamlessSx = {
  minWidth: 120,
  '& .MuiInputBase-root': { fontSize: '1.4rem' },
  '& .MuiInputBase-input': { padding: '4px 8px', textAlign: 'center' },
  '& .MuiOutlinedInput-root': { border: 'none' },
  '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
  '& .MuiOutlinedInput-input': { border: 'none' },
  '& .MuiOutlinedInput-input:focus': { border: 'none' },
  '& .MuiSelect-select': { padding: '4px 8px' },
  '& fieldset': { border: 'none' },
};

const SELECT_FIELD_TYPES = new Set(['SELECT', 'SINGLE_SELECT', 'MULTI_SELECT']);
const DATE_FIELD_TYPES = new Set(['DATE']);

export const BulkEditCell = ({ column, value, onChange, error }: Props) => {
  if (!column.isBulkEditable) {
    return (
      <span
        style={{
          fontSize: '1.4rem',
          color: '#224063',
          display: 'block',
          textAlign: 'center',
          padding: '4px 8px',
        }}
      >
        {value}
      </span>
    );
  }

  const options = column.options ?? [];

  if (SELECT_FIELD_TYPES.has(String(column.fieldType))) {
    return (
      <Select
        size="small"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        error={Boolean(error)}
        sx={seamlessSx}
        displayEmpty
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    );
  }

  if (DATE_FIELD_TYPES.has(String(column.fieldType))) {
    return (
      <TextField
        type="date"
        size="small"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        error={Boolean(error)}
        helperText={error}
        sx={seamlessSx}
        InputLabelProps={{ shrink: true }}
      />
    );
  }

  return (
    <TextField
      size="small"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      error={Boolean(error)}
      helperText={error}
      sx={seamlessSx}
    />
  );
};
